"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventReg = void 0;
const Form_1 = require("./Form");
const RegDto_1 = require("../dto/RegDto");
class EventReg {
    constructor(form) {
        this.state = RegDto_1.EventRegStateDto.DISABLED;
        this.approveType = RegDto_1.EventRegApproveTypeDto.AUTO;
        this.showRegItemsState = RegDto_1.ShowRegItemsStateDto.DISABLED;
        this.showRegItemsName = false;
        this.showRegItemsDate = false;
        this.showRegItemsFieldIds = [];
        this.created = 0;
        this.updated = 0;
        this.form = form;
    }
    static fromDto(dto) {
        var _a, _b, _c;
        const form = Form_1.Form.fromDto(dto.form);
        const result = new EventReg(form);
        result.state = dto.state;
        result.approveType = dto.approveType;
        if (dto.showRegItems) {
            result.showRegItemsState = dto.showRegItems.state;
            result.showRegItemsName = (_a = dto.showRegItems.showName) !== null && _a !== void 0 ? _a : false;
            result.showRegItemsDate = (_b = dto.showRegItems.showRegDate) !== null && _b !== void 0 ? _b : false;
            result.showRegItemsFieldIds = (_c = dto.showRegItems.fieldIds) !== null && _c !== void 0 ? _c : [];
        }
        result.created = dto.created;
        result.updated = dto.updated;
        return result;
    }
    toDto() {
        return {
            state: this.state,
            approveType: this.approveType,
            form: this.form.toDto(),
            showRegItems: this.toShowRegItemsDto(),
            created: this.created,
            updated: this.updated
        };
    }
    toShowRegItemsDto() {
        return {
            state: this.showRegItemsState,
            showName: this.showRegItemsName,
            showRegDate: this.showRegItemsDate,
            fieldIds: this.showRegItemsFieldIds
        };
    }
    toUpdateRequestDto() {
        return {
            state: this.state,
            approveType: this.approveType,
            showRegItems: this.toShowRegItemsDto(),
            updated: this.updated
        };
    }
    enabled(isPreview = false) {
        return this.state === RegDto_1.EventRegStateDto.ENABLED
            || (isPreview && this.state === RegDto_1.EventRegStateDto.DRAFT);
    }
    showRegItemsEnabled(isPreview = false) {
        return this.showRegItemsState === RegDto_1.ShowRegItemsStateDto.ENABLED
            || (isPreview && this.showRegItemsState === RegDto_1.ShowRegItemsStateDto.DRAFT);
    }
}
exports.EventReg = EventReg;
